export const setContentfulImageUrlProtocol = function (url: string | undefined | null) {
  if (!url) {
    return ''
  }
  const regex = /^\/\//
  return url.replace(regex, 'https://')
}
